module.exports = __webpack_public_path__ + "static/google-partner-abba787a3df77772170a33704ece1814.png";